var map = {
	"./theme3/battery-red.png": "CNVV",
	"./theme3/battery.png": "Hjdt",
	"./theme3/battery2.png": "H16w",
	"./theme3/dianchi.png": "a+8C",
	"./theme3/menus/close.png": "KphD",
	"./theme3/menus/open.png": "i4Oh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G33b";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/theme3.*$
// module id = G33b
// module chunks = 68